import IContactRepository from '../../2_domain/intro/iContactRepository';
import { ContactSlxInput } from '../../2_domain/intro/intro';
import Get from '../../lib/di/get';
import Connection from '../core/connection';
import { SEND_CONTACT_TO_SLX } from './contatctQuery';

class ContactRepository implements IContactRepository {
  //LINK - id 53
  //NOTE - NA
  async sendContactSlx(input: ContactSlxInput): Promise<void> {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    await client.mutate({
      mutation: SEND_CONTACT_TO_SLX,
      fetchPolicy: 'no-cache',
      variables: {
        input,
      },
    });
  }
}

export default ContactRepository;
